<template>
  <div class="left-box" :class="{ 'show-foot': showFoot }">
    <div class="left-top">
      <img src="../../../assets/img/camera-icon.png">
      <div class="name">
        {{ devName ? devName : '这是监控名称' }}
      </div>
      <div class="num">
        {{ !info.deviceId ? '这是监控id' : info.deviceId.indexOf('info') === -1 ? info.deviceId : info.deviceId.replace('info', '') }}
      </div>
    </div>
    <div class="left-content" ref="content">
      <easy-player
        v-if="showVideo"
        ref="videoPlay"
        class="videoPlay"
        live
        reconnection
        decode-type="wasm"
        :video-url="info.streams[videoIndex].hls"
        :style="{height: videoHeight}"
      />
    </div>
    <div class="video-bottom" v-if="showFoot">
      <!--      启动预警-->
<!--      <div class="box2"  @click="confirmWarning">启动预警</div>-->
      <div class="box2" @click="changeVideo">切换镜头</div>
    </div>
  </div>
</template>

<script>
import EasyPlayer from '@easydarwin/easyplayer';
export default {
  name: "videoDaHua",
  props: {
    info: { type: Object, default: () => {} },
    showFoot: { type: Boolean, default: true }
  },
  components: { EasyPlayer },
  data () {
    return {
      player: null,
      devName: '',
      playerAudioTime: 0,
      intervalTime: null,
      showVideo: false,
      videoHeight: 0,
      videoIndex: 3 // 播放源下标， 用于切换双镜头， 目前使用https 标清 就是 3和7
    }
  },
  watch: {
    info() {
      this.videoIndex = 3
      this.devName = this.info.deviceName
    }
  },
  mounted () {
    this.devName = this.info.deviceName
    this.videoHeight = (this.$refs.content.offsetWidth / 16 * 9) + 'px'
    this.$bus.on('editInfo', (form) => {
      if (form.deviceSerial && form.deviceSerial === this.info.deviceId) {
        this.devName = form.deviceName
      }
    })
    this.$nextTick(() => {
      this.showVideo = true
    })
  },
  beforeDestroy() {
    this.$bus.off('editInfo');
    this.$refs.videoPlay.destroyPlayer()
  },
  computed: {
    playTime () {
      return this.playerAudioTime <= 0
    }
  },
  methods: {
    confirmWarning () {
      return this.$message.warning('手动报警已失效')
    },
    changeVideo () {
      this.videoIndex = this.videoIndex === 3 ? 7 : 3
    }
  }
}
</script>

<style scoped lang="less">
.left-box{
  //height: 455px;
  background-image: url("../../../assets/img/left-box-bg.png");
  background-size: 100% 100%;
  padding: 2px 5px 10px 6px;
  position: relative;
  .left-top{
    padding: 5px 15px;
    display: flex;
    flex-wrap: wrap;
    font-size: 16px;
    position: relative;
    img{
      width: 24px;
      height: auto;
      margin-right: 5px;
    }
    .num{
      position: absolute;
      right: 10px;
    }
  }
  .v-bottom{
    height: 10px;
    width: 91.7%;
    margin-left: 8.6%;
    background-image: url("../../../assets/home/video-bottom.png");
    background-size: 100% 100%;
    position: relative;
    &:before{
      content: '';
      display: block;
      width: calc(100% - 4px);
      height: 3px;
      position: absolute;
      top: -1px;
      background-color: #3D3D3D;
    }
    //top: -2px;
  }
  .left-content{
    margin: 0 1px 0px 2px;
    //height: 360px;
    background-color: #3D3D3D;
    width: calc(100% - 3px);
    .videoPlay{
      width: 100%;
    }
  }
  .video-bottom{
    height: 55px;
    display: flex;
    justify-content: center;
    padding-top: 5px;
    position: absolute;
    bottom: 0;
    width: 100%;
    div{
      width: 160px;
      height: 50px;
      background-size: 100% 100%;
      text-align: center;
      line-height: 50px;
      font-size: 18px;
      cursor: pointer;
    }
    .box2{
      background-image: url("../../../assets/img/box2.png");
      color: #00FFF6;
    }
    .box4{
      background-image: url("../../../assets/img/box4.png");
      color: #00B2FF;
    }
  }
}
/deep/.audio-controls{
  display: none;
}
.show-foot{
  /deep/.audio-controls{
    display: block;
  }
}
.show-foot {
  padding-bottom: 60px;
}
/deep/ .easy-player-right-menu{
  display: none;
}
/deep/ .easy-player-loading{
  z-index: 9;
}
</style>
